import React, { Component } from 'react'
import { Card, Button, Table, Modal, message } from 'antd'

import LinkButton from '../../components/link-button/index'

import { connect } from 'react-redux'
import { req_list_role, req_list_member, req_add_member, req_edit_member, req_delete_member } from '../../api'

import UserModify from './user-modify'

import { PAGE_SIZE } from '../../utils/contrains'
import './user.less'

class User extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        user: {},
        users: [],
        roles: [],
        isShow: false
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.init_all()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_role = async () => {
        const token = this.props.user.token
        const result = await req_list_role(token)
        if (result.total > 0) {
            const roles = result.data.reduce((role_pre, role) => {
                role_pre.push({ roleCode: role.roleCode, roleName: role.roleName })
                return role_pre
            }, [])
            this.setState({ roles })
            this.mapping_roleNames_object(roles)
        }
        this.init_columns()
        this.api_list_member()
    }

    api_list_member = async () => {
        const token = this.props.user.token
        const result = await req_list_member(token)
        if (result.total > 0) {
            const users = result.data
            this.setState({ users })
        }
    }

    api_modify_member = async (user) => {
        const token = this.props.user.token
        //console.log(user)
        const result = (user.gidSysMember) ? await req_edit_member(user, token) : await req_add_member(user, token)
        if (result.status === 'success') {
            // 1 結果提示
            message.success((user.gidSysMember) ? '編輯成功' : '新增成功')
            this.form_modify.current.resetFields()
            this.setState({ isShow: false })
            // 2 更新列表
            this.api_list_member()
        } else {
            console.log(result)
        }
    }

    api_delete_member = async (id) => {
        const token = this.props.user.token
        const result = await req_delete_member(id, token)
        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_list_member()
        } else {
            console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        //console.log(this.roleNames)
        this.columns = [
            {
                title: '用戶名稱',
                dataIndex: 'anonymous'
            }, {
                title: '用戶帳號',
                dataIndex: 'accountCode'
            }, {
                title: '用戶密碼',
                dataIndex: 'unencryptedKey'
            }, {
                title: '用戶角色',
                dataIndex: 'roleAuthorityCode',
                // render: (roleAuthorityCode) => this.state.roles.find(role => role.roleCode === roleAuthorityCode).roleName
                render: (roleAuthorityCode) => this.roleNames_object[roleAuthorityCode] ? this.roleNames_object[roleAuthorityCode] : roleAuthorityCode
            },
            {
                title: '操作',
                render: (user) => (
                    <span>
                        <LinkButton onClick={() => this.handle_edit_show_ui(user)}>修改</LinkButton>
                        <LinkButton onClick={() => this.handle_delete_user(user)}>刪除</LinkButton>
                    </span>
                )
            }
        ]
    }

    mapping_roleNames_object = (roles) => {
        const roleNames = roles.reduce((role_pre, role) => {
            role_pre[role.roleCode] = role.roleName
            return role_pre
        }, {})
        this.roleNames_object = roleNames
    }

    init_all = () => {
        this.api_list_role()
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_edit_show_ui = (user) => {
        user.condition = 'base'
        this.setState({ isShow: true, user: user })
    }

    handle_add_show_ui = () => {
        this.setState({ isShow: true, user: {} })
    }

    handle_delete_user = (user) => {
        Modal.confirm({
            title: `您確定刪除${user.anonymous}用戶`,
            onOk: () => {
                this.api_delete_member(user.gidSysMember)
            }
        })
    }

    handle_modify_user = () => {
        this.form_modify.current.validateFields().then(values => {
            const user = values
            // console.log(user)
            this.api_modify_member(user)
        }).catch(error => {
            console.log(error.errorFields);
        });
    }

    ///////////////////////////////////////////////

    render() {
        const { user, users, roles, isShow } = this.state
        const title = (
            <span>
                <Button type="primary" onClick={this.handle_add_show_ui} >建立用戶</Button>
            </span>
        )
        return (
            <Card title={title}>
                <div>
                    <Table
                        bordered
                        rowKey='gidSysMember'
                        dataSource={users}
                        columns={this.columns}
                        pagination={{ defaultPageSize: PAGE_SIZE, showQuickJumper: true }}
                    />
                </div>

                <Modal 
                    destroyOnClose={true}
                    title={user.gidSysMember ? "異動用戶" : "新增用戶"}
                    visible={isShow}
                    onOk={this.handle_modify_user}
                    onCancel={() => {
                        this.form_modify.current.resetFields()
                        this.setState({ isShow: false })
                    }}

                >
                    <UserModify
                        setForm={(form) => this.form_modify = form}
                        roles={roles}
                        user={user}
                    />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(User)